import * as React from 'react';

import type { UseCurriculum_TopLevelPrereqFragment as TopLevelPrereq } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';
import { formatPrerequisites } from 'bundles/program-loggedin-shared/libraries/courseUtils';

import _t from 'i18n!nls/degree-home';

import { MetadataTypography } from '../../../../../program-loggedin-shared/components/Metadata';

/** The list of prerequisites for a course */
const Prerequisites = ({ prerequisite }: { prerequisite: TopLevelPrereq | null | undefined }) => {
  if (!prerequisite || !prerequisite.prerequisiteItems) {
    return null;
  }

  const formattedPrerequisites = formatPrerequisites(prerequisite);

  return (
    <React.Fragment>
      {!!formattedPrerequisites && (
        <MetadataTypography>
          {_t('Pre-requisites: #{prereqList}', {
            prereqList: formattedPrerequisites,
          })}
        </MetadataTypography>
      )}
    </React.Fragment>
  );
};

export default Prerequisites;
